// 樱花漫画网 - 漫画 mock 数据
// 仅用于未接入后端时的页面展示

export interface Manga {
  id: string;
  title: string;
  category: string; // 分类 slug
  categoryName: string;
  tags: string[];
  status: '连载中' | '已完结';
  chapters: number;
  latestChapter: string;
  rating: number;
  views: string;
  author: string;
  year: string;
  description: string;
  cover: string;
  updateTime: string;
  isNew?: boolean;
  isHot?: boolean;
  isComplete?: boolean;
}

export const categories = [
  { slug: 'shaonv', name: '少女漫画', icon: 'ri-heart-3-line', desc: '怦然心动的青春物语', count: 128 },
  { slug: 'lianai', name: '恋爱漫画', icon: 'ri-heart-line', desc: '甜蜜日常与心动瞬间', count: 96 },
  { slug: 'weimei', name: '唯美漫画', icon: 'ri-flower-line', desc: '如诗如画的治愈世界', count: 74 },
  { slug: 'danmei', name: '耽美漫画', icon: 'ri-moon-line', desc: '温柔细腻的动人故事', count: 58 },
];

export const mangas: Manga[] = [
  {
    id: 'ying-zhi-xia',
    title: '樱之夏',
    category: 'shaonv',
    categoryName: '少女漫画',
    tags: ['校园', '青春', '治愈'],
    status: '连载中',
    chapters: 46,
    latestChapter: '第46话 夏日祭的约定',
    rating: 9.4,
    views: '128.6万',
    author: '青木奈绪',
    year: '2023',
    description:
      '转学来的少女夏夜在樱花纷飞的校园里，与看似冷漠却温柔的少年相遇。一场关于成长、友情与初恋的夏日物语就此展开，每个瞬间都像被樱花温柔包裹。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20school%20girl%20with%20long%20dark%20hair%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20falling%2C%20warm%20sunlight%2C%20pastel%20background%2C%20romantic%20youth%20story%20style%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-yingzhixia&orientation=portrait',
    updateTime: '今天 10:24',
    isHot: true,
    isNew: true,
  },
  {
    id: 'xing-chen-zhi-yue',
    title: '星屑之约',
    category: 'shaonv',
    categoryName: '少女漫画',
    tags: ['奇幻', '校园', '悬疑'],
    status: '连载中',
    chapters: 32,
    latestChapter: '第32话 坠落的星',
    rating: 9.1,
    views: '86.3万',
    author: '朝雾友里',
    year: '2024',
    description:
      '每当流星划过，女主角便能看到别人看不见的星之碎片。她与命中注定的伙伴一起，追寻夜空深处隐藏的秘密，一步步接近世界的真相。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20girl%20reaching%20toward%20glowing%20star%20shards%20in%20a%20starry%20night%20sky%2C%20soft%20blue%20and%20pink%20glow%2C%20ethereal%20dreamy%20atmosphere%2C%20pastel%20background%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-xingchen&orientation=portrait',
    updateTime: '昨天 22:10',
  },
  {
    id: 'hu-die-jie-de-yu-ji',
    title: '蝴蝶结的雨季',
    category: 'shaonv',
    categoryName: '少女漫画',
    tags: ['治愈', '日常', '友情'],
    status: '已完结',
    chapters: 58,
    latestChapter: '已完结',
    rating: 9.6,
    views: '203.1万',
    author: '白井澄',
    year: '2022',
    description:
      '在漫长的梅雨季里，几位少女因为一场意外的合唱比赛而结缘。她们在湿润的空气里交换心事，也用歌声温暖了彼此晦暗的日子。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20two%20school%20girls%20holding%20umbrellas%20in%20the%20rain%2C%20pink%20ribbons%2C%20soft%20rain%20droplets%2C%20cozy%20warm%20pastel%20tones%2C%20gentle%20atmosphere%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-hudiejie&orientation=portrait',
    updateTime: '8月12日',
    isComplete: true,
    isHot: true,
  },
  {
    id: 'tong-zhuo-de-ta',
    title: '同桌的他',
    category: 'lianai',
    categoryName: '恋爱漫画',
    tags: ['校园', '恋爱', '日常'],
    status: '连载中',
    chapters: 39,
    latestChapter: '第39话 运动会之后',
    rating: 9.0,
    views: '74.8万',
    author: '藤原葵',
    year: '2024',
    description:
      '高二那一年，因为一张被掉包的课桌，成绩优异的优等生和吊车尾少年成了同桌。吵吵闹闹的日常里，怦然心动的瞬间正在悄悄发芽。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20teenage%20boy%20and%20girl%20sitting%20side%20by%20side%20at%20a%20school%20desk%2C%20spring%20classroom%2C%20warm%20sunlight%2C%20soft%20romantic%20pastel%20tones%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-tongzhuo&orientation=portrait',
    updateTime: '今天 08:40',
    isNew: true,
  },
  {
    id: 'xin-dong-xin-hao',
    title: '心动信号',
    category: 'lianai',
    categoryName: '恋爱漫画',
    tags: ['都市', '恋爱', '轻松'],
    status: '连载中',
    chapters: 51,
    latestChapter: '第51话 周末的约定',
    rating: 9.2,
    views: '112.5万',
    author: '佐仓绫香',
    year: '2023',
    description:
      '深夜电台主播与制作人之间的心动博弈。每一个深夜播出的声音，都藏着说不出口的心事。当真实的心动信号被捕捉，两人的关系开始悄悄改变。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20woman%20at%20a%20radio%20microphone%20at%20night%2C%20city%20lights%20bokeh%2C%20romantic%20warm%20amber%20and%20pink%20tones%2C%20cozy%20atmosphere%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-xindong&orientation=portrait',
    updateTime: '昨天 20:15',
    isHot: true,
  },
  {
    id: 'lian-ai-shuo-ming-shu',
    title: '恋爱说明书',
    category: 'lianai',
    categoryName: '恋爱漫画',
    tags: ['搞笑', '恋爱', '职场'],
    status: '已完结',
    chapters: 66,
    latestChapter: '已完结',
    rating: 8.9,
    views: '95.2万',
    author: '百田樱',
    year: '2022',
    description:
      '恋爱零经验的女程序员，决定像写程序一样严谨地"开发"属于自己的恋爱。每一步都按说明书执行，却总被脱线的男主打乱节奏，笑料百出。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20woman%20with%20a%20laptop%20and%20floating%20pink%20heart%20diagrams%2C%20cute%20playful%20style%2C%20bright%20pastel%20background%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-lianai&orientation=portrait',
    updateTime: '8月2日',
    isComplete: true,
  },
  {
    id: 'yue-jian-cao',
    title: '月见草',
    category: 'weimei',
    categoryName: '唯美漫画',
    tags: ['治愈', '日常', '自然'],
    status: '连载中',
    chapters: 28,
    latestChapter: '第28话 花开有时',
    rating: 9.5,
    views: '67.9万',
    author: '雾岛海音',
    year: '2024',
    description:
      '在静谧的乡村小屋里，照料花草的老人与前来寄宿的少女相遇。月见草在夜晚悄然绽放，也照亮了两个孤独灵魂彼此靠近的旅程。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20evening%20primrose%20flowers%20blooming%20at%20dusk%20in%20a%20quiet%20countryside%20garden%2C%20soft%20moonlight%2C%20tranquil%20healing%20pastel%20tones%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-yuejiancao&orientation=portrait',
    updateTime: '今天 09:05',
    isHot: true,
    isNew: true,
  },
  {
    id: 'wan-feng-lai-xin',
    title: '晚风来信',
    category: 'weimei',
    categoryName: '唯美漫画',
    tags: ['治愈', '书信', '怀旧'],
    status: '连载中',
    chapters: 24,
    latestChapter: '第24话 迟到的回信',
    rating: 9.3,
    views: '52.4万',
    author: '星野纱织',
    year: '2023',
    description:
      '在一家即将关门的旧书店里，女孩无意间发现了一叠未寄出的信。循着信中的线索，她与一位素未谋面的少年，展开了一场跨越时间的温柔通信。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20an%20old%20bookstore%20with%20warm%20lamplight%20and%20letters%20floating%20in%20the%20air%2C%20nostalgic%20evening%20breeze%2C%20soft%20golden%20and%20cream%20tones%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-wanfeng&orientation=portrait',
    updateTime: '昨天 18:30',
  },
  {
    id: 'wu-zhong-deng-ta',
    title: '雾中灯塔',
    category: 'weimei',
    categoryName: '唯美漫画',
    tags: ['奇幻', '治愈', '海洋'],
    status: '已完结',
    chapters: 40,
    latestChapter: '已完结',
    rating: 9.7,
    views: '158.3万',
    author: '苍井琥珀',
    year: '2022',
    description:
      '海雾笼罩的孤岛上，守塔人日复一日点亮灯塔。直到某天，一只会说话的海鸟带来少女的求救讯号，一场关于孤独、守护与告别的唯美冒险就此展开。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20lighthouse%20in%20sea%20fog%20with%20a%20seabird%20and%20a%20girl%20standing%20alone%2C%20dreamy%20ethereal%20muted%20tones%2C%20solemn%20yet%20gentle%20atmosphere%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-wuzhong&orientation=portrait',
    updateTime: '7月28日',
    isComplete: true,
    isHot: true,
  },
  {
    id: 'wu-hou-nuan-yang',
    title: '午后暖阳',
    category: 'danmei',
    categoryName: '耽美漫画',
    tags: ['都市', '治愈', '日常'],
    status: '连载中',
    chapters: 35,
    latestChapter: '第35话 阳台上的猫',
    rating: 9.2,
    views: '68.1万',
    author: '南野晴',
    year: '2024',
    description:
      '搬家后总是独自生活的设计师，在一次送错快递后认识了对门温柔的音乐人。两个性格迥异的人，在午后暖阳的日常里，慢慢学会了靠近彼此。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20two%20young%20men%20sitting%20on%20an%20apartment%20balcony%20with%20a%20cat%20in%20warm%20afternoon%20sunlight%2C%20cozy%20soft%20pastel%20tones%2C%20gentle%20romantic%20atmosphere%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-wuhou&orientation=portrait',
    updateTime: '今天 11:00',
    isHot: true,
    isNew: true,
  },
  {
    id: 'tong-xing-ban-sheng',
    title: '同行半生',
    category: 'danmei',
    categoryName: '耽美漫画',
    tags: ['都市', '温情', '长篇'],
    status: '连载中',
    chapters: 78,
    latestChapter: '第78话 同一把伞',
    rating: 9.6,
    views: '189.7万',
    author: '长谷川旬',
    year: '2023',
    description:
      '从青涩的高中同桌到步入社会的同行伙伴，两个少年在十多年的岁月里彼此扶持。那些没说出口的心意，藏在每一次并肩前行的脚步里。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20two%20young%20men%20walking%20side%20by%20side%20under%20a%20shared%20umbrella%20in%20soft%20rain%2C%20lifelong%20companionship%20feeling%2C%20warm%20muted%20tones%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-tongxing&orientation=portrait',
    updateTime: '昨天 23:20',
    isHot: true,
  },
  {
    id: 'zhi-jian-wen-du',
    title: '纸间温度',
    category: 'danmei',
    categoryName: '耽美漫画',
    tags: ['校园', '文艺', '治愈'],
    status: '已完结',
    chapters: 44,
    latestChapter: '已完结',
    rating: 9.0,
    views: '59.6万',
    author: '山田悠介',
    year: '2022',
    description:
      '图书管理员的文艺少年，与常来借书的运动系学弟在泛黄的书页间相遇。一段藏在图书馆角落的温柔暗恋，随着借书卡上的名字慢慢清晰。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20library%20with%20warm%20light%2C%20two%20boys%20sharing%20a%20book%2C%20bookshelves%2C%20nostalgic%20soft%20cream%20and%20rose%20tones%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-zhijian&orientation=portrait',
    updateTime: '7月15日',
    isComplete: true,
  },
  {
    id: 'hua-huo-ji-yuan',
    title: '花火纪元',
    category: 'new',
    categoryName: '日漫新番',
    tags: ['热血', '冒险', '连载'],
    status: '连载中',
    chapters: 12,
    latestChapter: '第12话 焰之试炼',
    rating: 9.3,
    views: '220.4万',
    author: '七濑炎',
    year: '2025',
    description:
      '在一个以烟火之力为信仰的异世界里，失去记忆的少年踏上寻找花火真源的旅途。热血的战斗、伙伴的羁绊，新番连载正火热同步中。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20hero%20surrounded%20by%20bursting%20fireworks%20in%20a%20fantasy%20world%2C%20epic%20adventure%20style%2C%20vibrant%20warm%20orange%20and%20pink%20energy%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-huahuo&orientation=portrait',
    updateTime: '今天 07:30',
    isNew: true,
    isHot: true,
  },
  {
    id: 'cang-qiong-shao-nv',
    title: '苍穹少女',
    category: 'new',
    categoryName: '日漫新番',
    tags: ['奇幻', '战斗', '成长'],
    status: '连载中',
    chapters: 16,
    latestChapter: '第16话 翼之觉醒',
    rating: 9.1,
    views: '96.8万',
    author: '伊吹翼',
    year: '2025',
    description:
      '生活在浮空城里的少女，偶然觉醒了操纵风的能力。她与伙伴们一同守护摇摇欲坠的天空之城，在新番连载中展开一段辽阔的成长之旅。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20girl%20with%20wind%20wings%20floating%20above%20a%20sky%20city%2C%20flying%20clouds%2C%20fantasy%20adventure%2C%20bright%20fresh%20pastel%20tones%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-cangqiong&orientation=portrait',
    updateTime: '昨天 21:05',
    isNew: true,
  },
  {
    id: 'yin-zhi-yao',
    title: '银之钥',
    category: 'new',
    categoryName: '日漫新番',
    tags: ['悬疑', '奇幻', '推理'],
    status: '连载中',
    chapters: 20,
    latestChapter: '第20话 门后的回声',
    rating: 9.4,
    views: '133.2万',
    author: '雾谷苍',
    year: '2024',
    description:
      '一把能打开"不该存在之门"的银色钥匙，让少年卷入接连发生的离奇事件。在推理与幻想的交织中，真相的钥匙正缓缓转动。',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20mysterious%20silver%20key%20and%20a%20glowing%20door%20in%20shadow%2C%20intrigue%20mystery%20atmosphere%2C%20cool%20silver%20and%20deep%20tones%2C%20high%20detail%20digital%20art&width=600&height=900&seq=cover-yinzhiyao&orientation=portrait',
    updateTime: '今天 12:00',
    isHot: true,
  },
];

// 首页精选专题
export const featuredCollections = [
  {
    id: 'col-summer',
    title: '夏日心动特辑',
    subtitle: '蝉鸣、冰饮与怦然心动',
    desc: '精选 12 部适合在夏日阅读的恋爱与青春漫画，让甜度与热度一起攀升。',
    tag: '恋爱专题',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20summer%20beach%20with%20cherry%20blossom%20motif%2C%20popsicle%20and%20umbrella%2C%20soft%20pink%20and%20aqua%20pastel%20palette%2C%20dreamy%20youth%20atmosphere%2C%20wide%20banner%2C%20high%20detail%20digital%20art&width=1200&height=700&seq=col-summer&orientation=landscape',
  },
  {
    id: 'col-heal',
    title: '治愈系深夜书房',
    subtitle: '适合安静阅读的温柔作品',
    desc: '在睡不着的夜晚，这些唯美与治愈系漫画会像一杯热牛奶般抚慰你的心。',
    tag: '治愈专题',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20cozy%20night%20study%20with%20warm%20lamp%20and%20teacup%2C%20books%20and%20potted%20plant%2C%20soft%20cream%20and%20amber%20tones%2C%20peaceful%20healing%20atmosphere%2C%20wide%20banner%2C%20high%20detail%20digital%20art&width=1200&height=700&seq=col-heal&orientation=landscape',
  },
  {
    id: 'col-stars',
    title: '星夜幻想录',
    subtitle: '奇幻与冒险的璀璨合集',
    desc: '当幻想照进现实，这些充满想象力的新番连载将带你奔赴广袤的星辰大海。',
    tag: '奇幻专题',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20starry%20night%20sky%20with%20shooting%20stars%20and%20floating%20islands%2C%20fantasy%20adventure%2C%20soft%20deep%20blue%20and%20pink%20glow%2C%20wide%20banner%2C%20high%20detail%20digital%20art&width=1200&height=700&seq=col-stars&orientation=landscape',
  },
];

// 首页轮播主打
export const heroSlides = [
  {
    id: 'hero-1',
    tag: '本周热门',
    title: '花火纪元',
    sub: '热血冒险新番，火热同步更新中',
    desc: '在烟火之力的异世界，追查花火真源的少年燃起了整个夏天的热情。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20anime%20illustration%20of%20fireworks%20bursting%20over%20a%20fantasy%20city%20at%20dusk%2C%20warm%20pink%20and%20orange%20sky%2C%20silhouette%20of%20a%20young%20hero%2C%20epic%20atmosphere%2C%20high%20detail%20digital%20art&width=1600&height=900&seq=hero-1&orientation=landscape',
  },
  {
    id: 'hero-2',
    tag: '甜度满分',
    title: '樱之夏',
    sub: '少女恋爱治愈物语',
    desc: '樱花纷飞的校园里，一场关于成长与初恋的夏日故事悄然盛开。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20anime%20illustration%20of%20cherry%20blossom%20petals%20drifting%20over%20a%20sunlit%20school%20courtyard%2C%20soft%20pink%20pastel%20tones%2C%20romantic%20youth%20atmosphere%2C%20high%20detail%20digital%20art&width=1600&height=900&seq=hero-2&orientation=landscape',
  },
  {
    id: 'hero-3',
    tag: '完结推荐',
    title: '雾中灯塔',
    sub: '唯美治愈系口碑佳作',
    desc: '海雾孤岛上的守塔人，用一盏灯火守护一场温柔的告别。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20anime%20illustration%20of%20a%20lighthouse%20on%20a%20misty%20isolated%20island%20under%20a%20soft%20pink%20dusk%20sky%2C%20ethereal%20dreamy%20atmosphere%2C%20high%20detail%20digital%20art&width=1600&height=900&seq=hero-3&orientation=landscape',
  },
];